var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6C16 5.44772 15.5523 5 15 5C14.4477 5 14 5.44772 14 6H16ZM15 15H14C14 15.2652 14.1054 15.5196 14.2929 15.7071L15 15ZM20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L20.2929 21.7071ZM6 14C5.44772 14 5 14.4477 5 15C5 15.5523 5.44772 16 6 16V14ZM7 16C7.55228 16 8 15.5523 8 15C8 14.4477 7.55228 14 7 14V16ZM16 23C16 22.4477 15.5523 22 15 22C14.4477 22 14 22.4477 14 23H16ZM14 24C14 24.5523 14.4477 25 15 25C15.5523 25 16 24.5523 16 24H14ZM24 16C24.5523 16 25 15.5523 25 15C25 14.4477 24.5523 14 24 14V16ZM23 14C22.4477 14 22 14.4477 22 15C22 15.5523 22.4477 16 23 16V14ZM27 15C27 21.6274 21.6274 27 15 27V29C22.732 29 29 22.732 29 15H27ZM15 27C8.37258 27 3 21.6274 3 15H1C1 22.732 7.26801 29 15 29V27ZM3 15C3 8.37258 8.37258 3 15 3V1C7.26801 1 1 7.26801 1 15H3ZM15 3C21.6274 3 27 8.37258 27 15H29C29 7.26801 22.732 1 15 1V3ZM14 6V15H16V6H14ZM14.2929 15.7071L20.2929 21.7071L21.7071 20.2929L15.7071 14.2929L14.2929 15.7071ZM6 16H7V14H6V16ZM14 23V24H16V23H14ZM24 14H23V16H24V14Z",
    fill: "#FF6700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f867027a25e8a752630e63081d52d535.svg";
export { ForwardRef as ReactComponent };